import { render, staticRenderFns } from "./TrainingChart.vue?vue&type=template&id=0f27404b"
import script from "./TrainingChart.vue?vue&type=script&lang=js"
export * from "./TrainingChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports